import React from 'react';
import './Blog.css';
import Arrow_Right from '../../data/img/Arrow - Right.png';
import blog1 from '../../data/img/blogi.png';
import blog2 from '../../data/img/blog2.png';
import blog3 from '../../data/img/blog3.png';
import level from '../../data/img/Scrool Down.png';
import scrollBtn from '../../data/img/tobuttom.png';
import scroll_effect from './../../utils/scroll_effect';

const Blog = () => {
    scroll_effect('.blog-effect', 1.5)
    const scrollBottomToTop = ()=>{
        window.scrollTo({
            top: 7000,
            behavior: "smooth"
        })
    }
    return (
        <>
            <div className="blog-aria">
            <div className="container">
                <div>
                    <div className="top-section">
                        <h2>Arbitrage</h2>
                        <div>
                            <p>Arbitrage is a superior and revolutionary solution for gaining money for the new generation. In today’s modern world, Arbitrage can become a new business model according to the current situation and the future of humankind in this dataism era.</p>
                            <button className="read-more-btn">
                                Read <p>More<img src={Arrow_Right} alt=""/></p>
                            </button>
                        </div>
                    </div>
                    <div className="button-section blog-effect">
                        <div>
                            <div>
                                <img src={blog1} alt=""/>
                                <h3>Algorithms</h3>
                                <p>There are so many algorithms that BVarb.com is using for the betterment of its system and to keep the working of BVarb.com updated and up to date...</p>
                                <button className="read-more-btn">
                                    Read <p>More<img src={Arrow_Right} alt=""/></p>
                                </button>
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src={blog2} alt=""/>
                                <h3>Big Data</h3>
                                <p>Big data is basically a great volume of data with variety of innovative information, cost effective sources other than that have high decision...</p>
                                <button className='read-more-btn'>
                                    Read <p>More<img src={Arrow_Right} alt=""/></p>
                                </button>
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src={blog3} alt=""/>
                                <h3>Algorithms</h3>
                                <p>There are so many algorithms that BVarb.com is using for the betterment of its system and to keep the working of BVarb.com updated and up to date...</p>
                                <button className="read-more-btn">
                                    Read <p>More<img src={Arrow_Right} alt=""/></p>
                                </button>
                            </div>
                        </div>
                        <div className='scroll-dow-container'>
                            <img className="scroll-img" src={level} alt=""/>
                            <br/>
                            <img onClick={scrollBottomToTop} className="mouse-img" src={scrollBtn} alt=""/>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default Blog;